import App from './App.vue';
import { registerRouterHooks } from './router';
import loadConfig from './config/config';
import { store } from './store';
import '@simonwep/pickr/dist/themes/monolith.min.css';
import '@simonwep/pickr/dist/themes/classic.min.css';
import { LOAD_WORKSPACES } from './store/app/actionTypes';
import authService from './authentication/authentication.service';
import 'vue-material-design-icons/styles.css';
import 'v-calendar/style.css';
import Chart from 'chart.js/auto';
// @ts-ignore
import { CrosshairPlugin } from 'chartjs-plugin-crosshair';
import Annotation from 'chartjs-plugin-annotation';
import ChartjsPluginStacked100 from 'chartjs-plugin-stacked100';
import { DoughnutLabelPlugin } from './features/reports/components/chartjs/plugins/doughnutLabels/plugin';
import { InlineLabelsPlugin } from './features/reports/components/chartjs/plugins/inlineLabelsPlugin';
import { LOAD_CONTACT_ATTRIBUTES } from '@/store/attributes/actionTypes';
import { GET_CHANNEL_IDENTITIES } from './store/channel-identities/actionTypes';
import appInsights from './shared/services/appInsights';

import 'vue-toastification/dist/index.css';
import './style.scss';
import { createAppWithPlugins } from '@/utils/createAppWithPlugins';

Chart.register(CrosshairPlugin, Annotation, ChartjsPluginStacked100, InlineLabelsPlugin, DoughnutLabelPlugin);

init().then();

async function init() {
  await loadConfig();
  authService.setup();
  await authService.load(); // need to wait for initial redirect to complete

  appInsights.init(); // Initialise the app insights service
  registerRouterHooks(); // only enforce authentication in our routes once we know the auth service has been initialised

  if (authService.isAuthenticated() && authService.isConnectUser()) {
    appInsights.setAuthenticatedUserContext();
    await store.dispatch(LOAD_WORKSPACES);
    await store.dispatch(LOAD_CONTACT_ATTRIBUTES);
    await store.dispatch(GET_CHANNEL_IDENTITIES);
  }

  const app = createAppWithPlugins(App);
  app.mount('#app');
}
